
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "163e0baa5eb79f8c5ac1d5e79b1d30c8ac38d747",
  "nuxt": {
    "buildId": "e7dc3dbf-5afc-4f6a-aeec-082dc7341221"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
